<template>
  <div class="pad-top-5">
    <van-pull-refresh v-show="showGroup" v-model="refreshing" @refresh="onRefresh">
      <div class="custom-steps">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell v-for="doc in groupData" :key="doc.psgId">
            <template #title>
              <div v-show="!isSingle" class="list-check-box flex flex-align-center">
                <van-checkbox v-model="checkGroups[doc.psgId]" :ref="doc.psgId+'-group'"
                              shape="square" icon-size="16px"
                              @click="handleCheckGroup(doc)"></van-checkbox>
              </div>
              <div @click="showGroupUsers(doc)">
                <span class="color-box mar-rgt-10"><i class="fa fa-object-group text-sm"></i></span>
                <span class="custom-title">{{doc.name}}（{{doc.members.length}}人）</span>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </van-pull-refresh>
    <transition name="van-slide-right">
      <user-check-cell v-show="aimPsGroup"
                       v-bind="psgGroupInfo"
                       @change-users="changeUsers"
                       @pre-dept="showGroupList"></user-check-cell>
    </transition>
  </div>
</template>

<script>
  import {refreshDebounce} from "../../../../../tools/utils";
  import {personalGroup} from "../../../../../server"
  import UserCheckCell from './UserCheckCell'

  export default {
    components: {UserCheckCell},
    props: {
      singleUserId: String,
      selectedUserIds: Array,
      selectedInfo: Object,
      isSingle: Boolean,  // 是否单选
    },
    data() {
      return {
        refreshing: false,
        refreshTime: "",
        groupMap: {},
        finished: false,
        loading: false,
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
        showGroup: true,
        checkGroups: {},
        aimPsGroup: null,
      }
    },
    computed: {
      groupData() {
        return Object.values(this.groupMap).flat(1)
      },
      psgGroupInfo() {
        // console.log(this.aimPsGroup)
        return {
          cellInfo: this.aimPsGroup ? {
            deptId: "psGroup",
            title: this.aimPsGroup.name,
            groups: [],
          } : {},
          userList: this.aimPsGroup && this.aimPsGroup.members || [],
          selectedInfo: this.selectedInfo,
          singleUserId: this.singleUserId,
          isSingle: this.isSingle,
        }
      },
    },
    watch: {
      selectedUserIds(val) {
        // console.log("selectedUserIds", val);
        this.groupData.forEach(doc => {
          const {psgId, members = []} = doc;
          const checked = members.every(e => val.includes(e.userId));
          if (this.checkGroups[psgId] === checked) return;
          this.checkGroups = {...this.checkGroups, [psgId]: checked};
        })
      },
    },
    methods: {
      onRefresh() {
        // 刷新防抖动
        if (this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        this.initGroupList()
      },
      initGroupList() {
        this.pageInfo.pageNum = 1;
        this.refreshTime = "";
        this.groupMap = {};
        this.finished = false;
        this.onLoad()
      },
      onLoad() {
        this.getGroupList(this.pageInfo.pageNum++)
      },
      getGroupList(pageNum) {
        const filter = {
          pageNum,
          pageSize: this.pageInfo.pageSize,
        };
        !this.refreshing && !this.loading && UILoader.load();
        personalGroup.queryList(this, {queryFilter: filter}).then(({searchPersonalGroup: data = {}}) => {
          UILoader.unload();
          // 列表懒加载
          this.loading = false;
          const {personalGroupEdges, pageInfo} = data;
          // console.log(personalGroupEdges);
          this.groupMap = {
            ...this.groupMap,
            [pageNum]: (personalGroupEdges || []).map(e => {
              // format checkGroups
              const {psgId, members = []} = e.personalGroup;
              const checked = members.every(e => this.selectedUserIds.includes(e.userId));
              this.checkGroups = {...this.checkGroups, [psgId]: checked};
              return {...e.personalGroup}
            }).filter(e => e.members && e.members.length)
          };
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.refreshTime = new Date();
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
        }).catch(err => {
          UILoader.unload();
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          vtToast(err.message)
        })
      },
      handleCheckGroup(doc) {
        this.$emit('change-group-users', doc.members, this.checkGroups[doc.psgId], "psg")
      },
      showGroupUsers(doc) {
        this.$emit('change-group-users', doc.members, null, "psg", true);  // 仅做用户信息存储
        this.aimPsGroup = doc;
        this.showGroup = false
      },
      showGroupList() {
        this.aimPsGroup = null;
        this.showGroup = true
      },
      changeUsers(data) {
        // (单选 || 新增) || 删除
        if (this.isSingle || data.length > this.selectedUserIds.length) {
          this.$emit('change-users', data)
        } else {
          const removeUid = this.selectedUserIds.find(uid => !data.includes(uid));
          this.$emit('remove-user', removeUid)
        }
      },
    }
  }
</script>

<style scoped>
</style>
